import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggleBtn"]

  toggle() {
    const isOpen = !this.panelTarget.classList.contains("translate-x-full")
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full")
    this.toggleBtnTarget.classList.add("hidden")
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.toggleBtnTarget.classList.remove("hidden")
  }
}
